import React from 'react';
import './StoreLoader.css';

// Full-screen loader shown while the store resolves: two brand-colored arcs
// turning in opposite directions around a soft track, with the store's name
// underneath once it is known. Neutral on purpose, since Elvix serves
// restaurants, bars, cafés and more.
const StoreLoader = ({ name = '', label = 'Loading store…' }) => (
    <div className="store-loader" role="status" aria-label={name ? `${label} ${name}` : label}>
        <svg className="store-loader__art" viewBox="0 0 100 100" aria-hidden="true">
            <circle className="store-loader__track" cx="50" cy="50" r="40" />
            <circle className="store-loader__arc store-loader__arc--outer" cx="50" cy="50" r="40" />
            <circle className="store-loader__arc store-loader__arc--inner" cx="50" cy="50" r="26" />
            <circle className="store-loader__core" cx="50" cy="50" r="6" />
        </svg>
        {name && (
            <p
                className="store-loader__name" aria-hidden="true"
            >
                {name}
            </p>
        )}
    </div>
);

export default StoreLoader;
